import React from "react";
import ButtonArrow from "../components/ButtonArrow";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { axiosConfig } from "../Helpers/AxiosRequest";
import Entrepreneur from "../components/Entrepreneur";
import CarouselComponent from "../components/CarouselComponent";
import { useHeader } from "../Contexts/HeaderContext";
import { API_URL } from "../Helpers/api";
import shuffleArray from "../Helpers/ShuffleArray";
import { Helmet } from "react-helmet";
import entrepreneursImg from "../Images/tia_rafa.webp"

const Entrepreneurs = () => {
  // const { marginTop } = useHeader();
  const [entrepreneurs, setEntrepreneurs] = useState();

  useEffect(() => {
    axios(axiosConfig("GET", `${API_URL}/advertising/get-active-adds/entrepreneur`, null, true))
      .then((res) => {
        if (res.data.success) {
          const shuffledAdds = shuffleArray(res.data.adds);
          setEntrepreneurs(shuffledAdds);
        } else {
          console.warn("No entrepreneur adds found");
        }
      })
      .catch((err) => console.error(err.message));
  }, []);

  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Emprendimientos en Bella Unión – Proyectos Locales y Cultura</title>
        <meta
          name="description"
          content="Conoce los emprendimientos locales de Bella Unión: proyectos sostenibles que impulsan la economía y preservan nuestra identidad cultural."
        />
        <meta
          name="keywords"
          content="emprendimientos Bella Unión, proyectos locales Uruguay, economía sostenible Bella Unión, identidad cultural, turismo comunitario"
        />
        <link rel="canonical" href="https://bellaunion.uy/emprendimientos" />
        <meta property="og:title" content="Emprendimientos en Bella Unión – Proyectos Locales y Cultura" />
        <meta
          property="og:description"
          content="Conoce los emprendimientos locales de Bella Unión: proyectos sostenibles que impulsan la economía y preservan nuestra identidad cultural."
        />
        <meta property="og:url" content="https://bellaunion.uy/emprendimientos" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={entrepreneursImg} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Emprendimientos en Bella Unión – Proyectos Locales y Cultura" />
        <meta
          name="twitter:description"
          content="Conoce los emprendimientos locales de Bella Unión: proyectos sostenibles que impulsan la economía y preservan nuestra identidad cultural."
        />
        <meta name="twitter:image" content={entrepreneursImg} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Empredimientos</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light" id="main-container" style={{ marginTop: "100vh" }}>
        <div className="container py-5">
          <h2 className="text-center mb-5">Visibilidad y Oportunidades para Emprendedores de Uruguay</h2>
          <div className="row g-0 justify-content-center">
            {entrepreneurs?.length > 0 ? (
              <>
                <div className="row g-0 justify-content-center">
                  {entrepreneurs.map((entrepreneur, i) => (
                    <>
                      <Entrepreneur data={entrepreneur} index={i} key={entrepreneur._id} />
                    </>
                  ))}
                </div>
              </>
            ) : (
              <p className="fs-2 fw-light text-center">No se encontraron emprendedores</p>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Entrepreneurs;
